module.exports = __webpack_public_path__ + "img/瓯海区教育局拷贝.0dbfda1c.png";